import { defineMessages } from 'react-intl-next';

export default defineMessages({
    dropdownNumberOfSearchResultsLabel: {
        id: 'cv.request.create.form.cmdbobjectpicker.numberofsearchresultslabel',
        defaultMessage: `{numberOfSearchResults, plural, one {# search result} other {# search results}}`,
        description: 'Description above cmdb objects options describing how many objects were found',
    },
    dropdownMaxNumberOfSearchResultsLabel: {
        id: 'cv.request.create.form.cmdbobjectpicker.maxnumberofsearchresultslabel',
        defaultMessage: '{maxObjectCountCutoff}+ search results',
        description: 'Description above cmdb objects options describing how many objects were found',
    },
    errorFlagTitle: {
        id: 'cv.request.create.form.cmdbobjectpicker.errorFlagTitle',
        defaultMessage: `We couldn't fetch any results for this search`,
        description: 'Title for error flag that is triggered when searching for CMDB objects fails',
    },
    errorFlagDescription: {
        id: 'cv.request.create.form.cmdbobjectpicker.errorFlagDescription',
        defaultMessage: `Ask your team or admin for support.`,
        description: 'Description for error flag that is triggered when searching for CMDB objects fails',
    },
});
